import type {LoaderFunctionArgs} from 'react-router'
import {redirect, useLoaderData} from 'react-router-dom'

import {getNavigationState} from '../../../helpers/navigationStateCache.ts'
import {getInitialProps} from './getInitialProps'
import TechnicalDetailsVehicleComponent from './index.js'

// Import styles
import './styles/index.scss'

export async function loader({context, request, params}: LoaderFunctionArgs) {
  const url = new URL(request.url)
  const pathname = url.pathname
  const query = Object.fromEntries(url.searchParams.entries())

  // Build routeInfo compatible with getInitialProps
  const routeInfo = {
    location: {
      pathname,
      query,
      search: url.search,
      state: getNavigationState(pathname)
    },
    params: {
      make: params.make,
      model: params.model,
      bodyType: params.bodyType,
      doors: params.doors,
      version: params.version,
      versionId: params.versionId,
      vehicleId: params.vehicleId
    }
  }

  // Call existing getInitialProps
  const data = await getInitialProps({routeInfo, context})

  const redirectTo: unknown = data?.__HTTP__?.redirectTo
  if (typeof redirectTo === 'string' && redirectTo !== '') {
    return redirect(redirectTo)
  }

  return data
}

export function Component() {
  const data = useLoaderData()
  return <TechnicalDetailsVehicleComponent {...data} />
}
